import { createContext, useContext, type ReactNode } from 'react';
import type { AppRuntime } from '../runtime';

const RuntimeContext = createContext<AppRuntime | null>(null);

export function RuntimeProvider({
  runtime,
  children,
}: {
  runtime: AppRuntime;
  children?: ReactNode;
}) {
  return <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>;
}

/** The app runtime (fetcher, session store, event bus…). Throws outside <RuntimeProvider>. */
export function useRuntime(): AppRuntime {
  const runtime = useContext(RuntimeContext);
  if (!runtime) throw new Error('useRuntime needs a <RuntimeProvider>');
  return runtime;
}
